"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropper = exports.dropperPageAtom = void 0;
var recoil_1 = require("recoil");
var recoils_1 = require("../recoils");
/**
 * 最後にスポイトで選択された page number を保持する Atom
 * useEffect の参照一致を潜り抜けるためにオブジェクトにする
 */
exports.dropperPageAtom = recoil_1.atom({
    key: 'dropperPageAtom',
    default: { index: 0 }
});
function useDropper() {
    return recoil_1.useRecoilCallback(function (_a, x, y) {
        var e_1, _b;
        var _c, _d;
        var getLoadable = _a.getLoadable, set = _a.set;
        var sceneMapLoadable = getLoadable(recoils_1.sceneMapState);
        var sceneMap = sceneMapLoadable.state === 'hasValue'
            ? sceneMapLoadable.contents
            : undefined;
        if (!sceneMap)
            return;
        var pagesLoadable = getLoadable(recoils_1.palettePagesState);
        var pages = pagesLoadable.state === 'hasValue' ? pagesLoadable.contents : undefined;
        if (!pages)
            return;
        for (var layer = 0; layer < sceneMap.tables.length; layer++) {
            var index = (_d = (_c = sceneMap.tables[layer]) === null || _c === void 0 ? void 0 : _c[y]) === null || _d === void 0 ? void 0 : _d[x];
            if (index > 0) {
                try {
                    // index から page を見つける
                    for (var pages_1 = (e_1 = void 0, __values(pages)), pages_1_1 = pages_1.next(); !pages_1_1.done; pages_1_1 = pages_1.next()) {
                        var page = pages_1_1.value;
                        for (var y_1 = 0; y_1 < page.row; y_1++) {
                            for (var x_1 = 0; x_1 < 8; x_1++) {
                                var num = y_1 * 8 + x_1;
                                var tile = page.tiles[num];
                                if ((tile === null || tile === void 0 ? void 0 : tile.index) === index) {
                                    set(recoils_1.paletteSelectionState, {
                                        page: page.index,
                                        start: { col: x_1, row: y_1, num: num },
                                        end: { col: x_1, row: y_1, num: num }
                                    });
                                    set(recoils_1.cursorModeState, 'pen');
                                    set(exports.dropperPageAtom, { index: page.index });
                                    return;
                                }
                            }
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (pages_1_1 && !pages_1_1.done && (_b = pages_1.return)) _b.call(pages_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return;
            }
        }
    }, []);
}
exports.useDropper = useDropper;
//# sourceMappingURL=useDropper.js.map